import { render, staticRenderFns } from "./OxySelectorsPanel.vue?vue&type=template&id=9ecb21ca&"
import script from "./OxySelectorsPanel.vue?vue&type=script&lang=ts&"
export * from "./OxySelectorsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports